import Carousel from "./Carousel";
export default function Characters() {
  return (
    <section
      id="characters"
      className="w-full pt-[48px] md:pt-[100px] pb-[36px] md:pb-0"
    >
      <div className="flex flex-col gap-[24px] md:gap-[60px]">
        <div className="max-w-[255px] md:max-w-[640px] mx-auto flex flex-col gap-[12px] md:gap-[25px] text-center">
          <h2>Выбирайте своих собеседников</h2>
          <p className="subtitle">
            В приложении более 20 персонажей с разными характерами, а если все
            персонажи тебе не подходят, ты можешь создать себе своего
          </p>
        </div>

        <Carousel />
      </div>
    </section>
  );
}
